import React, { ReactNode } from 'react'
import styled from 'styled-components'
import PlaceHolderUser from 'assets/placeholder-user.png'
import { colors } from 'utils'

const S = {
    Wrapper: styled.div<{ active?: boolean }>`
        width: 100%;
        // min-height is required for safari. Otherwise, the height of item will be reduce in a overflow-y:auto container.
        min-height: 35px;
        display: flex;
        padding: 5px 0;
        background-color: ${({ active }) => (active ? 'rgba(48, 104, 244, 0.05)' : 'transparent')}!important;
        cursor: pointer;
        overflow: hidden;
    `,
    InfoWrapper: styled.div`
        flex: 1;
        display: flex;
        align-items: center;
        margin-right: 10px;
        overflow: hidden;
    `,
    Image: styled.img<{ squareImage?: boolean }>`
        width: ${({ squareImage }) => (squareImage ? 56 : 35)}px;
        height: ${({ squareImage }) => (squareImage ? 40 : 35)}px;
        border-radius: ${({ squareImage }) => (squareImage ? '3px' : '50%')};
        object-fit: cover;
        object-position: center;
    `,
    Info: styled.div`
        flex: 1;
        overflow: hidden;
        margin-left: 10px;
    `,
    Name: styled.div<{ isBoldName?: boolean }>`
        font-size: 14px;
        line-height: 20px;
        color: ${colors.grayTitle};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: ${({ isBoldName }) => (isBoldName ? 500 : 400)};
    `,
    Description: styled.div`
        font-size: 14px;
        color: ${colors.icon};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
    Icons: styled.div`
        display: flex;
        align-items: center;
        cursor: pointer;
        padding-bottom: 4px;
        & > * {
            margin-right: 16px;
        }
    `,
    ExtraInfo: styled.div`
        display: flex;
        align-items: center;
    `
}

interface Props {
    active?: boolean
    children?: ReactNode
    name?: string
    description?: string
    image?: string
    className?: string
    onClick?: () => void
    style?: React.CSSProperties
    isBoldName?: boolean
    squareImage?: boolean
    renderExtraInfo?: () => ReactNode
    renderTagsIndicator?: () => ReactNode
}

const InfoItem = ({
    active,
    children,
    name,
    description,
    image,
    className,
    onClick,
    style,
    isBoldName = true,
    squareImage,
    renderExtraInfo,
    renderTagsIndicator,
}: Props) => (
    <S.Wrapper active={active} className={className} style={style}>
        <S.InfoWrapper onClick={onClick}>
            {renderTagsIndicator?.()}
            <S.Image src={image || PlaceHolderUser} className="info-image" squareImage={squareImage} />
            <S.Info className="info-wrapper">
                <S.Name className="info-wrapper__name" isBoldName={isBoldName}>{name}</S.Name>
                <S.Description className="info-wrapper__description">
                    {description}
                </S.Description>
            </S.Info>
        </S.InfoWrapper>
        <S.ExtraInfo>
            {renderExtraInfo?.()}
        </S.ExtraInfo>
        <S.Icons className="info-actions">
            {children}
        </S.Icons>
    </S.Wrapper>
)

export default InfoItem
